package com.tregz.tremenz.ui.route

import com.tregz.tremenz.ui.icon.IconKey
import com.tregz.tremenz.ui.label.LabelKey

enum class RouteKey(
    val icon: IconKey,
    val label: LabelKey,
    val hasPlayer: Boolean
) {
    MIXES(IconKey.INSTANT_MIX, LabelKey.ROUTE_MIXES, hasPlayer = true),
    PLAYLISTS(IconKey.MUSIC, LabelKey.ROUTE_EDITS, hasPlayer = true),
    RADIO(IconKey.RADIO, LabelKey.ROUTE_CHANNELS, hasPlayer = true)
}
